const routes = [
  {
    path: '',
    component: () => import('@/views/provider/dispenseManagement/Wrapper.vue'),
    children: [
      {
        path: '/provider/dispenseManagement',
        name: 'DispenseManagement',
        component: () => import('@/views/provider/dispenseManagement/Main.vue'),
      },
      {
        path: 'dispenseManagement/dispensation-request/:dispensationRequestId?',
        name: 'dispensation-request-view',
        component: () =>
          import(
            '@/views/provider/specialists/dipensation-request/DispensationRequest'
          ),
        meta: {
          title: 'Solicitud de Dispensa',
        },
      },
    ],
  },
];

export default routes;
